import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { MultiInput, MultiInputClientValidator } from '../../MultiInput'
import { messages } from './messages'

interface Props {
  name: string
  label: string
  state: FormState
  disabled?: boolean
}

export const UTM_VALID_CHARS = /^([a-zA-Z0-9_-]*)$/

export function UTMField(props: Props) {
  const { name, label, state, disabled } = props

  const { formatMessage: i18n } = useIntl()

  const values: string[] = useWatch({ form: state, name })

  const restrictsSpecialCharacters: MultiInputClientValidator = (
    text: string
  ) => {
    const hasOnlyValidChars = Boolean(text.match(UTM_VALID_CHARS))

    return hasOnlyValidChars
      ? { valid: true }
      : { valid: false, message: i18n(messages.invalidChars) }
  }

  return (
    <MultiInput
      name={name}
      label={label}
      values={values}
      onChange={(vals: string[]) => state.setValue(name, vals)}
      inputValidation={restrictsSpecialCharacters}
      disabled={disabled}
    />
  )
}
